/* Page favoris (app proxy Wishlist Hero) : badges de stock sur les cartes,
   comme l'encart « Bientôt en rupture » du panier. Le widget React ne rend pas
   l'inventaire : on lit /products/<handle>?view=stock (templates/product.stock.liquid)
   et on pose le badge sur la zone image. Memes bornes que le panier :
   stock strictement entre 0 et 20, survente (policy continue) exclue.

   Attention : React reutilise les noeuds DOM des cartes quand la liste change
   (fusion locale/compte a la connexion, suppression, tri). Le traitement est
   donc rattache au handle du produit, pas au noeud : si une carte se met a
   afficher un autre produit, son badge est retire et son stock reevalue. */
(function () {
  var SEUIL = 20;
  var stockCache = {};
  var lastCartAddAt = 0;

  /* ---- Popin « Ajoute au panier ! » du theme sur les ajouts wishlist ----
     L'app poste {id, quantity} en XHR JSON vers /cart/add.js puis affiche son
     propre toast MUI. On enrichit sa requete des sections attendues par
     cart-notification (meme mecanique que product-form.js) et on ouvre la
     popin du theme avec la reponse ; le toast MUI devenu redondant est retire
     par le scan(). Si quoi que ce soit echoue, la requete part inchangee et
     le toast de l'app reprend la main. */
  (function () {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._wlhCartAdd = String(method).toUpperCase() === 'POST'
        && /\/cart\/add(\.js)?$/.test(String(url || '').split('?')[0]);
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._wlhCartAdd && typeof body === 'string' && document.querySelector('cart-notification')) {
        try {
          var data = JSON.parse(body);
          data.sections = 'cart-notification-product,cart-notification-button,cart-icon-bubble';
          /* pas le chemin courant : le rendu de sections ne fonctionne pas
             dans le contexte d'une URL d'app proxy */
          data.sections_url = '/';
          body = JSON.stringify(data);
          var xhr = this;
          this.addEventListener('load', function () {
            if (xhr.status < 200 || xhr.status >= 300) return;
            try {
              var resp = JSON.parse(xhr.responseText);
              var key = resp.key || (resp.items && resp.items[0] && resp.items[0].key);
              var notif = document.querySelector('cart-notification');
              if (notif && resp.sections && key) {
                lastCartAddAt = Date.now();
                notif.renderContents(Object.assign({}, resp, { key: key }));
              }
            } catch (e) { /* reponse inattendue : le toast de l'app reste visible */ }
          });
        } catch (e) { /* corps non JSON : requete laissee telle quelle */ }
      }
      return origSend.call(this, body);
    };
  })();

  function getStock(handle) {
    if (!stockCache[handle]) {
      stockCache[handle] = fetch('/products/' + handle + '?view=stock')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (t) { return JSON.parse(t); })
        .catch(function () { return null; });
    }
    return stockCache[handle];
  }

  function decorate(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return; /* carte pas encore hydratee : le prochain scan repassera */

    var url = new URL(link.href, location.origin);
    var m = url.pathname.match(/\/products\/([^/?]+)/);
    if (!m) return;
    var handle = m[1];
    var variantId = parseInt(url.searchParams.get('variant'), 10);

    if (card.dataset.wlhStockHandle === handle) return;
    card.dataset.wlhStockHandle = handle;
    card.querySelectorAll('.wlh-badge').forEach(function (b) { b.remove(); });

    getStock(handle).then(function (data) {
      /* le noeud a pu etre reaffecte a un autre produit pendant le fetch */
      if (card.dataset.wlhStockHandle !== handle) return;
      if (!data || !data.variants) return;
      var v = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === variantId) { v = data.variants[i]; break; }
      }
      v = v || data.variants[0];
      if (!v || !v.managed) return;

      var label = null;
      var cls = '';
      if (!v.available) {
        label = 'Épuisé';
        cls = 'wlh-badge--epuise';
      } else if (v.policy !== 'continue' && v.qty > 0 && v.qty < SEUIL) {
        label = 'Bientôt en rupture';
        cls = 'wlh-badge--rupture';
      }
      if (!label) return;

      var img = card.querySelector('.wishlist-hero-list-card-product-image');
      var host = img && img.closest('a');
      if (!host || host.querySelector('.wlh-badge')) return;
      host.classList.add('wlh-badge-host');
      var badge = document.createElement('span');
      badge.className = 'wlh-badge ' + cls;
      badge.textContent = label;
      host.appendChild(badge);
    });
  }

  /* Coeur doodle trace main (charte : doodles marron, en fin de titre) */
  var DOODLE = '<svg class="wlh-doodle" width="__S__" height="__S__" viewBox="0 0 32 30" fill="none" aria-hidden="true"><path d="M16 26.5C10 21.5 4 16.8 3.2 10.9 2.7 6.9 5.7 3.5 9.3 3.7c2.7.2 4.9 2 6.4 4.5 1.3-2.7 3.7-4.7 6.5-4.6 3.7.2 6.6 3.5 6 7.5-.8 5.8-6.5 10.3-12.2 15.4z" stroke="#402719" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Titre « Mes favoris » -> « Mes *favoris* » + doodle, comme les titres de la marque */
  function styleTitle() {
    var h1 = document.querySelector('h1.wishlist-hero-page-header');
    if (!h1 || h1.dataset.wlhStyled) return;
    var text = (h1.textContent || '').trim();
    if (!text) return;
    h1.dataset.wlhStyled = '1';
    var words = text.split(/\s+/);
    var last = words.pop();
    h1.textContent = words.length ? words.join(' ') + ' ' : '';
    var em = document.createElement('em');
    em.textContent = last;
    h1.appendChild(em);
    h1.insertAdjacentHTML('beforeend', DOODLE.replace(/__S__/g, '30'));
  }

  /* Etat vide : doodle + CTA vers le catalogue */
  function styleEmpty() {
    var empty = document.querySelector('.wishlist-hero-list-no-items-text');
    if (!empty || empty.dataset.wlhStyled) return;
    empty.dataset.wlhStyled = '1';
    empty.insertAdjacentHTML('afterbegin', '<div class="wlh-empty-doodle">' + DOODLE.replace(/__S__/g, '54').replace('class="wlh-doodle" ', '') + '</div>');
    empty.insertAdjacentHTML('beforeend', '<div><a class="wlh-empty-cta" href="/collections/tous-les-produits">Découvrir nos produits</a></div>');
  }

  function scan() {
    styleTitle();
    styleEmpty();
    document.querySelectorAll('.wishlist-hero-list-card').forEach(decorate);
    /* toast MUI redondant avec la popin du theme juste apres un ajout ;
       les autres snackbars (retrait d'un favori, erreurs) restent visibles.
       Masquer, ne JAMAIS retirer : ces noeuds appartiennent a React, qui
       plante au demontage s'ils ont disparu du DOM (page d'erreur beige). */
    if (Date.now() - lastCartAddAt < 4000) {
      document.querySelectorAll('.MuiSnackbar-root').forEach(function (s) { s.style.display = 'none'; });
    }
  }

  /* childList pour les cartes ajoutees/retirees, attributes href pour les
     noeuds que React reutilise en changeant simplement leurs liens. */
  new MutationObserver(scan).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
  scan();
})();
